import request from '@/utils/request'


// 查询楼层楼栋列表
export function listBuildingFloor(query) {
  return request({
    url: '/building/building/floor/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询楼层楼栋分页
export function pageBuildingFloor(query) {
  return request({
    url: '/building/building/floor/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询楼层楼栋详细
export function getBuildingFloor(data) {
  return request({
    url: '/building/building/floor/detail',
    method: 'get',
    params: data
  })
}

// 新增楼层楼栋
export function addBuildingFloor(data) {
  return request({
    url: '/building/building/floor/add',
    method: 'post',
    data: data
  })
}

// 修改楼层楼栋
export function updateBuildingFloor(data) {
  return request({
    url: '/building/building/floor/edit',
    method: 'post',
    data: data
  })
}

// 删除楼层楼栋
export function delBuildingFloor(data) {
  return request({
    url: '/building/building/floor/delete',
    method: 'post',
    data: data
  })
}
